/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/home.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { Component } from "@angular/core";
import { VisionIcsApiService } from "vics/visionics/api/ng/index";
import { User } from "./auth/user";
import { Vhost } from "./context/vhost";
import * as i0 from "@angular/core";
import * as i1 from "./context/vhost";
import * as i2 from "./auth/user";
import * as i3 from "vics/visionics/api/ng/index";
import * as i4 from "@angular/material/card";
export class HomeComponent {
    /**
     * @param {?} vhost
     * @param {?} user
     * @param {?} api
     */
    constructor(vhost, user, api) {
        this.vhost = vhost;
        this.user = user;
        this.api = api;
        if (this.user.isAuthenticated()) {
            /** @type {?} */
            const coordinators = api.listCoordinator();
            coordinators.subscribe(console.log);
        }
    }
}
HomeComponent.decorators = [
    { type: Component, args: [{
                templateUrl: "home.component.html",
            },] },
];
/** @nocollapse */
HomeComponent.ctorParameters = () => [
    { type: Vhost },
    { type: User },
    { type: VisionIcsApiService }
];
/** @nocollapse */ HomeComponent.ɵfac = function HomeComponent_Factory(t) { return new (t || HomeComponent)(i0.ɵɵdirectiveInject(i1.Vhost), i0.ɵɵdirectiveInject(i2.User), i0.ɵɵdirectiveInject(i3.VisionIcsApiService)); };
/** @nocollapse */ HomeComponent.ɵcmp = i0.ɵɵdefineComponent({ type: HomeComponent, selectors: [["ng-component"]], decls: 22, vars: 2, consts: [[1, "example-card"], ["href", "/documentation/home"], ["href", "/dataentry"], ["href", "/report"], ["href", "/site_list"], ["href", "/session"]], template: function HomeComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-card", 0);
        i0.ɵɵelementStart(1, "mat-card-content");
        i0.ɵɵelementStart(2, "h2");
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "p");
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "ul");
        i0.ɵɵelementStart(7, "li");
        i0.ɵɵelementStart(8, "a", 1);
        i0.ɵɵtext(9, "Documentation");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "li");
        i0.ɵɵelementStart(11, "a", 2);
        i0.ɵɵtext(12, "Data entry");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "li");
        i0.ɵɵelementStart(14, "a", 3);
        i0.ɵɵtext(15, "Reports");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "li");
        i0.ɵɵelementStart(17, "a", 4);
        i0.ɵɵtext(18, "Sites");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "li");
        i0.ɵɵelementStart(20, "a", 5);
        i0.ɵɵtext(21, "Sessions");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.vhost.title);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1("Welcome to ", ctx.vhost.title, "!");
    } }, directives: [i4.MatCard, i4.MatCardContent], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(HomeComponent, [{
        type: Component,
        args: [{
                templateUrl: "home.component.html",
            }]
    }], function () { return [{ type: i1.Vhost }, { type: i2.User }, { type: i3.VisionIcsApiService }]; }, null); })();
if (false) {
    /** @type {?} */
    HomeComponent.prototype.vhost;
    /** @type {?} */
    HomeComponent.prototype.user;
    /**
     * @type {?}
     * @private
     */
    HomeComponent.prototype.api;
}
//# sourceMappingURL=data:application/json;base64,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